import React, { useRef, useState } from "react"
import { Megaphone } from "lucide-react"
import Analytic from "../../assets/analytics-with-excel.jpeg"
import Accounting from "../../assets/accounting.jpeg"
import AI from "../../assets/artificial-intelligence.jpeg"
import Business from "../../assets/business-management.jpeg"
import computing from "../../assets/computing.jpeg"
import Coding from "../../assets/coding.jpeg"
import MovingAnimation from "../../assets/moving-animation.jpeg"
import Medicine from "../../assets/medicine.jpeg"
import Governments from "../../assets/governments.jpeg"
import Leadership from "../../assets/leadership.jpeg"
import Html from "../../assets/html.jpeg"
import Environment from "../../assets/environment.jpeg"
import Engineering from "../../assets/engineering.jpeg"
import Statistics from "../../assets/statistics.jpeg"
import GraphicDesign from "../../assets/graphic-design.jpeg"

const skills = [
  { title: "Moving Animation", img: MovingAnimation },
  { title: "Medicine", img: Medicine },
  { title: "Governments", img: Governments },
  { title: "Leadership", img: Leadership },
  { title: "HTML", img: Html },
  { title: "Environment", img: Environment },
  { title: "Engineering", img: Engineering },
  { title: "Statistics", img: Statistics },
  { title: "Graphic Design", img: GraphicDesign },
  { title: "Large Language Models", img: Accounting },
  { title: "Machine Learning", img: AI },
  { title: "Analytic", img: Analytic },
  { title: "Coding", img: Coding },
  { title: "Computing", img: computing },
  { title: "Business Management", img: Business },
]

const topRow = skills.slice(0, Math.ceil(skills.length / 2))
const bottomRow = skills.slice(Math.ceil(skills.length / 2))

function ScrollRow({ items }) {
  const rowRef = useRef(null)
  const rafRef = useRef(null)
  const [active, setActive] = useState(false)

  const handleMouseMove = (e) => {
    const row = rowRef.current
    if (!row) return

    const { left, width } = row.getBoundingClientRect()
    const x = e.clientX - left        // cursor x relative to row
    const ratio = x / width            // 0 (far left) → 1 (far right)
    const deadzone = 0.35              // middle 30% = no scroll

    let speed = 0
    if (ratio < deadzone) {
      // left zone — scroll left, faster closer to edge
      speed = -((deadzone - ratio) / deadzone) * 8
    } else if (ratio > 1 - deadzone) {
      // right zone — scroll right
      speed = ((ratio - (1 - deadzone)) / deadzone) * 8
    }

    cancelAnimationFrame(rafRef.current)

    if (speed !== 0) {
      const scroll = () => {
        row.scrollLeft += speed
        rafRef.current = requestAnimationFrame(scroll)
      }
      rafRef.current = requestAnimationFrame(scroll)
    }
  }

  const handleMouseLeave = () => {
    cancelAnimationFrame(rafRef.current)
    setActive(false)
  }

  return (
    <div
      ref={rowRef}
      onMouseMove={handleMouseMove}
      onMouseEnter={() => setActive(true)}
      onMouseLeave={handleMouseLeave}
      className="flex gap-6 overflow-x-auto cursor-none"
      style={{ scrollbarWidth: "none", msOverflowStyle: "none" }}
    >
      <style>{`.row-no-scrollbar::-webkit-scrollbar { display: none; }`}</style>
      {[...items, ...items, ...items].map((skill, i) => (
        <SkillCard key={i} skill={skill} />
      ))}
    </div>
  )
}

export default function Skills() {
  return (
    <section className="pb-8 bg-blue-100 overflow-hidden">
      <div className="w-full h-12 bg-blue-500 text-white border-4 my-8
                      flex items-center gap-3 px-6 font-medium">
        <Megaphone size={18} />
        <span>Advertisements</span>
      </div>

      <div className="max-w-7xl mx-auto space-y-10 px-6">
        <ScrollRow items={topRow} />
        <ScrollRow items={bottomRow} />
      </div>
    </section>
  )
}

function SkillCard({ skill }) {
  return (
    <div className="bg-white p-4 rounded-xl shadow flex flex-col items-center
                    min-w-[220px] hover:-translate-y-2 transition flex-shrink-0">
      <img
        src={skill.img}
        alt={skill.title}
        className="w-48 h-48 object-cover rounded-xl mb-3"
      />
      <h3 className="font-bold text-center text-sm">{skill.title}</h3>
      <p className="text-xs text-gray-500">Explore courses</p>
    </div>
  )
}